(function () {
  'use strict';

  function updateMobileViewportHeight() {
    if (!window.matchMedia('(max-width: 990px)').matches) return;
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  }

  function bindMobileMenuViewportFix() {
    updateMobileViewportHeight();
    window.addEventListener('resize', updateMobileViewportHeight, { passive: true });
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      if (target.closest('menu-drawer > details > summary, header-drawer > details > summary')) {
        requestAnimationFrame(updateMobileViewportHeight);
      }
    });
  }

  function resetBuildYourOwnButtons() {
    var roots = document.querySelectorAll('[id^="kb-build-"]');
    roots.forEach(function (root) {
      var total = root.querySelector('[data-total]');
      var hasSelection = total && total.textContent.trim() !== '0g';
      root.querySelectorAll('[data-cart]').forEach(function (button) {
        if (button.dataset.originalText) button.textContent = button.dataset.originalText;
        if (hasSelection) button.disabled = false;
      });
    });
  }

  function bindBuildYourOwnBackFix() {
    window.addEventListener('pageshow', function () {
      window.setTimeout(resetBuildYourOwnButtons, 50);
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        window.setTimeout(resetBuildYourOwnButtons, 50);
      }
    });
  }

  function forceKushiProductBackground() {
    function apply() {
      document.querySelectorAll('.kb-product-page').forEach(function (el) {
        el.style.setProperty('background', '#F4F5F8', 'important');
      });
      document.querySelectorAll('.kb-product-page').forEach(function (el) {
        var section = el.closest('.shopify-section');
        if (section) section.style.setProperty('background', '#F4F5F8', 'important');
      });
    }
    apply();
    document.addEventListener('shopify:section:load', apply);
    window.setTimeout(apply, 100);
    window.setTimeout(apply, 500);
  }

  function patchSlideshowRuntime() {
    var Slideshow = customElements.get('slideshow-component');
    if (!Slideshow || !Slideshow.prototype) return;

    var proto = Slideshow.prototype;
    if (proto.__kushiSafetyPatched) return;

    proto.__kushiSafetyPatched = true;
    var originalSetAutoPlay = proto.setAutoPlay;
    var originalFocusInHandling = proto.focusInHandling;

    proto.setAutoPlay = function () {
      if (!this.reducedMotion) {
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      }
      if (typeof this.announcementBarArrowButtonWasClicked !== 'boolean') {
        this.announcementBarArrowButtonWasClicked = false;
      }
      if (typeof originalSetAutoPlay === 'function') return originalSetAutoPlay.call(this);
    };

    proto.focusInHandling = function (event) {
      if (typeof this.announcementBarArrowButtonWasClicked !== 'boolean') {
        this.announcementBarArrowButtonWasClicked = false;
      }
      if (!this.announcementBarSlider) {
        return;
      }
      return originalFocusInHandling.call(this, event);
    };
  }

  function applyKushiGalleryArrowStyle() {
    var styleId = 'kushi-gallery-arrow-style';
    var style = document.getElementById(styleId);
    if (!style) {
      style = document.createElement('style');
      style.id = styleId;
      document.head.appendChild(style);
    }
    style.textContent = '.kb-product-page .kb-gallery-arrow{background:transparent!important;border:0!important;box-shadow:none!important;color:var(--kb-accent)!important;width:44px;height:44px;min-width:44px;min-height:44px;font-weight:700}.kb-product-page .kb-gallery-arrow:hover{background:transparent!important;color:var(--kb-accent)!important}.kb-product-page .kb-gallery-arrow:focus-visible{outline:2px solid var(--kb-accent)!important;outline-offset:2px}.kb-product-page .kb-gallery-arrow:active{background:transparent!important}';
  }

  function initRuntimePatches() {
    patchSlideshowRuntime();
  }

  initRuntimePatches();

  function init() {
    bindMobileMenuViewportFix();
    bindBuildYourOwnBackFix();
    forceKushiProductBackground();
    applyKushiGalleryArrowStyle();
    initRuntimePatches();
    window.setTimeout(initRuntimePatches, 50);
    window.setTimeout(initRuntimePatches, 250);
    window.setTimeout(applyKushiGalleryArrowStyle, 100);
    window.setTimeout(applyKushiGalleryArrowStyle, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
